import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import TimerRoundedIcon from "@mui/icons-material/TimerRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Chip, Paper, Stack, Typography } from "@mui/material";
import { useSimulationStats } from "@/features/simulation/public";

/**
 * 画面右上に浮遊するHUD風の統計パネル。
 * 稼働状況 / 完成数 / サイクル / スループット / コンベア停止のステータスを表示。
 *
 * MUI 9 で Stack/Typography の system shortcut props（alignItems / fontWeight 等）が
 * 削除されたため、本ファイルでは sx にまとめる。
 */
export function StatsPanel() {
  const { stats, running, conveyorStopped } = useSimulationStats();

  const cycle = stats.lastCycleTimeSec === null ? "—" : `${stats.lastCycleTimeSec.toFixed(2)} 秒`;

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        top: 16,
        right: 16,
        px: 2,
        py: 1.5,
        minWidth: 260,
        borderRadius: 3,
        backdropFilter: "blur(8px)",
        background: "rgba(255,255,255,0.92)",
      }}
    >
      <Stack spacing={1.25}>
        <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            ライン稼働状況
          </Typography>
          <Chip size="small" color={running ? "success" : "default"} label={running ? "稼働中" : "停止中"} />
        </Stack>

        {conveyorStopped && (
          <Chip
            size="small"
            color="warning"
            icon={<WarningAmberRoundedIcon />}
            label="コンベア自動停止中（バッファ満杯）"
            sx={{ justifyContent: "flex-start" }}
          />
        )}

        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <CheckCircleRoundedIcon color="success" fontSize="small" />
          <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
            累計完成数
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {stats.completedCount}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <TimerRoundedIcon color="primary" fontSize="small" />
          <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
            直近サイクル
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            {cycle}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <TrendingUpRoundedIcon color="secondary" fontSize="small" />
          <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
            スループット
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            {stats.throughputPerMin} /分
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
}
